export const HelpersMixin = {
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },

  methods: {
    loadButton (isLoading) {
      let loadableButtons = this.$el.querySelectorAll(".loadable-button");
      for (let loadableButton of loadableButtons) {
        if (isLoading) {
          loadableButton.classList.add("is-loading");
        } else {
          loadableButton.classList.remove("is-loading");
        }
      }
    },

    windowTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
};
